/*
  Lichcards — glansveeg en uitvoeringslabel over de kaartfoto.

  Wat het WEL is: een interface-effect dat zegt "deze kaart is folie". Wat het
  NIET is: een bewerkte foto. Daarom:
    · alleen wanneer de regel de uitvoering ZEKER weet (kind is gevuld);
    · nooit op de terugvalgevallen (onbekende rarity, gegradeerde slabs);
    · holo en reverse krijgen een ander patroon, want bij reverse zit de folie
      juist overal BEHALVE op de illustratie;
    · het label blijft de harde informatie — de glans is versiering.

  Server-side staat de beginwaarde er al in; dit script houdt hem bij als de
  klant van uitvoering wisselt. Ella vervangt bij een variantwissel het hele
  <variant-selects>-element, dus er wordt gedelegeerd op document.
*/
(function () {
  'use strict';

  if (window.__lcFinishFx) return;
  window.__lcFinishFx = true;

  var SHINE_MS = 1200;

  function isEditionInput(el) {
    if (!el || !el.name) return false;
    var n = el.name.toLowerCase();
    return n.indexOf('edition') !== -1 || n.indexOf('editie') !== -1;
  }

  function readMap(node) {
    try {
      return JSON.parse(node.getAttribute('data-map') || '{}');
    } catch (e) {
      return {};
    }
  }

  /* De ruwe Cardmarket-waarde van de gekozen uitvoering, of null. */
  function selectedRaw(root) {
    var checked = root.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < checked.length; i++) {
      if (isEditionInput(checked[i])) return checked[i].value;
    }
    var selects = root.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      if (isEditionInput(selects[j])) return selects[j].value;
    }
    return null;
  }

  function apply(raw) {
    var nodes = document.querySelectorAll('lc-fx[data-map]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var map = readMap(node);
      var entry = raw == null ? null : map[raw];
      if (!entry) continue;

      var kind = entry.k || '';
      var label = entry.l || '';
      if (node.getAttribute('data-kind') !== kind) {
        node.setAttribute('data-kind', kind);
      }
      var chip = node.querySelector('[data-lc-fx-chip]');
      if (chip && chip.textContent !== label) chip.textContent = label;
    }
  }

  function onChange(e) {
    if (!isEditionInput(e.target)) return;
    apply(e.target.value);
  }

  /* Even laten glanzen bij aanraken; op desktop doet :hover het werk. */
  function shine(el) {
    var media = el.closest ? el.closest('.product-media') : null;
    if (!media || media.classList.contains('lc-fx-shine')) return;
    media.classList.add('lc-fx-shine');
    window.setTimeout(function () {
      media.classList.remove('lc-fx-shine');
    }, SHINE_MS);
  }

  function onPointer(e) {
    if (e.pointerType && e.pointerType === 'mouse') return;
    if (e.target && e.target.closest && e.target.closest('.product-media')) {
      shine(e.target);
    }
  }

  document.addEventListener('change', onChange, true);
  document.addEventListener('pointerdown', onPointer, { passive: true });

  /* Bij het laden is de server-waarde al goed; na een sectie-herrender van
     Ella kan de kiezer verder staan dan de foto. Eén keer gelijktrekken. */
  function sync() {
    apply(selectedRaw(document));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();